/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MeRouteImport } from './routes/me'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MeIndexRouteImport } from './routes/me/index'
import { Route as MeInviteRouteImport } from './routes/me_.invite'
import { Route as MeSettingsRouteImport } from './routes/me/_settings'
import { Route as MeSettingsProfileRouteImport } from './routes/me/_settings/profile'
import { Route as MeSettingsLiveblogProfilesRouteImport } from './routes/me/_settings/liveblog-profiles'
import { Route as MeSettingsAccountRouteImport } from './routes/me/_settings/account'

const MeRoute = MeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MeIndexRoute = MeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MeRoute,
} as any)
const MeInviteRoute = MeInviteRouteImport.update({
  id: '/me_/invite',
  path: '/me/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const MeSettingsRoute = MeSettingsRouteImport.update({
  id: '/_settings',
  getParentRoute: () => MeRoute,
} as any)
const MeSettingsProfileRoute = MeSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => MeSettingsRoute,
} as any)
const MeSettingsLiveblogProfilesRoute =
  MeSettingsLiveblogProfilesRouteImport.update({
    id: '/liveblog-profiles',
    path: '/liveblog-profiles',
    getParentRoute: () => MeSettingsRoute,
  } as any)
const MeSettingsAccountRoute = MeSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => MeSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/me': typeof MeRouteWithChildren
  '/me/invite': typeof MeInviteRoute
  '/me/': typeof MeIndexRoute
  '/me/account': typeof MeSettingsAccountRoute
  '/me/liveblog-profiles': typeof MeSettingsLiveblogProfilesRoute
  '/me/profile': typeof MeSettingsProfileRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/me': typeof MeIndexRoute
  '/me/invite': typeof MeInviteRoute
  '/me/account': typeof MeSettingsAccountRoute
  '/me/liveblog-profiles': typeof MeSettingsLiveblogProfilesRoute
  '/me/profile': typeof MeSettingsProfileRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/me': typeof MeRouteWithChildren
  '/me/_settings': typeof MeSettingsRouteWithChildren
  '/me_/invite': typeof MeInviteRoute
  '/me/': typeof MeIndexRoute
  '/me/_settings/account': typeof MeSettingsAccountRoute
  '/me/_settings/liveblog-profiles': typeof MeSettingsLiveblogProfilesRoute
  '/me/_settings/profile': typeof MeSettingsProfileRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/me'
    | '/me/invite'
    | '/me/'
    | '/me/account'
    | '/me/liveblog-profiles'
    | '/me/profile'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/me'
    | '/me/invite'
    | '/me/account'
    | '/me/liveblog-profiles'
    | '/me/profile'
  id:
    | '__root__'
    | '/'
    | '/me'
    | '/me/_settings'
    | '/me_/invite'
    | '/me/'
    | '/me/_settings/account'
    | '/me/_settings/liveblog-profiles'
    | '/me/_settings/profile'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MeRoute: typeof MeRouteWithChildren
  MeInviteRoute: typeof MeInviteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/me': {
      id: '/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof MeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/': {
      id: '/me/'
      path: '/'
      fullPath: '/me/'
      preLoaderRoute: typeof MeIndexRouteImport
      parentRoute: typeof MeRoute
    }
    '/me_/invite': {
      id: '/me_/invite'
      path: '/me/invite'
      fullPath: '/me/invite'
      preLoaderRoute: typeof MeInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/_settings': {
      id: '/me/_settings'
      path: ''
      fullPath: '/me'
      preLoaderRoute: typeof MeSettingsRouteImport
      parentRoute: typeof MeRoute
    }
    '/me/_settings/profile': {
      id: '/me/_settings/profile'
      path: '/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof MeSettingsProfileRouteImport
      parentRoute: typeof MeSettingsRoute
    }
    '/me/_settings/liveblog-profiles': {
      id: '/me/_settings/liveblog-profiles'
      path: '/liveblog-profiles'
      fullPath: '/me/liveblog-profiles'
      preLoaderRoute: typeof MeSettingsLiveblogProfilesRouteImport
      parentRoute: typeof MeSettingsRoute
    }
    '/me/_settings/account': {
      id: '/me/_settings/account'
      path: '/account'
      fullPath: '/me/account'
      preLoaderRoute: typeof MeSettingsAccountRouteImport
      parentRoute: typeof MeSettingsRoute
    }
  }
}

interface MeSettingsRouteChildren {
  MeSettingsAccountRoute: typeof MeSettingsAccountRoute
  MeSettingsLiveblogProfilesRoute: typeof MeSettingsLiveblogProfilesRoute
  MeSettingsProfileRoute: typeof MeSettingsProfileRoute
}

const MeSettingsRouteChildren: MeSettingsRouteChildren = {
  MeSettingsAccountRoute: MeSettingsAccountRoute,
  MeSettingsLiveblogProfilesRoute: MeSettingsLiveblogProfilesRoute,
  MeSettingsProfileRoute: MeSettingsProfileRoute,
}

const MeSettingsRouteWithChildren = MeSettingsRoute._addFileChildren(
  MeSettingsRouteChildren,
)

interface MeRouteChildren {
  MeSettingsRoute: typeof MeSettingsRouteWithChildren
  MeIndexRoute: typeof MeIndexRoute
}

const MeRouteChildren: MeRouteChildren = {
  MeSettingsRoute: MeSettingsRouteWithChildren,
  MeIndexRoute: MeIndexRoute,
}

const MeRouteWithChildren = MeRoute._addFileChildren(MeRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MeRoute: MeRouteWithChildren,
  MeInviteRoute: MeInviteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
